import { pickBy, equals } from 'ramda';

export const preserveChangedValues = <T>(newValues: T, oldValues: T): Partial<T> => {
  return pickBy((value, key) => !equals(value, oldValues[key as keyof T]), newValues);
};
